import React from "react";
import { useLocation } from "react-router-dom";

const LIGHT_PREFIXES = ["/app", "/product", "/checkout", "/profile", "/orders"];

export const PoweredFooter = () => {
  const { pathname } = useLocation();
  const light = LIGHT_PREFIXES.some((p) => pathname.startsWith(p));
  return (
    <footer
      data-testid="powered-by-footer"
      className={`relative z-10 py-4 text-center text-xs border-t ${light ? "bg-white border-slate-200 text-slate-500" : "bg-[#05070A] border-cyan-500/10 text-slate-500"}`}
    >
      Powered by{" "}
      <a
        href="https://www.streamlinestacksolutions.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="powered-by-link"
        className={`font-semibold hover:underline ${light ? "text-emerald-700" : "text-cyan-300"}`}
      >
        Streamline Stack Solutions
      </a>
    </footer>
  );
};
